import React, { useEffect } from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import AOS from "aos";
import "aos/dist/aos.css";
import "./AboutUs.css";
import placeholderImg from "../../Assets/hero.jpg"; // Temporäres Symbolbild

function AboutUs() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="about-modern" id="about">
      <h2 className="section-title" data-aos="fade-up">
        Über Uns
      </h2>
      <div className="about-wrapper">
        <div className="about-content" data-aos="fade-left">
          <h2>Wir sind kein Club. Wir sind Familie.</h2>
          <p className="lead-text">
            Seit 1984 stehen bei uns Menschen im Fokus – nicht nur Ergebnisse.
          </p>
          <ul className="about-highlights">
            <li>40 Jahre Engagement im Breitensport</li>
            <li>Über 100 aktive Mitglieder</li>
            <li>Jugend- und Seniorenförderung</li>
            <li>Veranstaltungen, die verbinden</li>
          </ul>

          <Link to="/about-us" className="btn-erfahren">
  Mehr Erfahren
</Link>

        </div>
        <div className="about-image" data-aos="fade-right">
          <img src={placeholderImg} alt="VfB Johannesberg Team" />
        </div>
      </div>
    </section>
  );
}

export default AboutUs;